import { BoardSections, Task } from "../models/Kanban";
import { KanbanBoardStatus } from "../types";
import { getTasksByStatus } from "./GetTasks";

export const initializeBoard = (tasks: Task[] = []) => {
  const boardSections: BoardSections = {
    draft: [],
    live: [],
    archived: [],
  };

  Object.entries(KanbanBoardStatus).forEach(([, value]) => {
    boardSections[value] = getTasksByStatus(tasks || [], value);
  });

  return boardSections;
};


export const findBoardSectionContainer = (
  boardSections: BoardSections,
  id: string
) => {
  if (id in boardSections) {
    return id;
  }

  return Object.keys(boardSections).find((key) =>
    boardSections[key as KanbanBoardStatus].find((item) => item.id === id)
  );
};
